import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthCtx";
import AuthService from "../../api/auth";

export default function GoogleLoginPage() {
  const [searchParams] = useSearchParams();
  const [code, setCode] = useState(null);

  const authCtx = useAuth();

  useEffect(() => {
    const code = searchParams.get("code");
    if (code) {
      setCode(code);
    }
  }, [searchParams]);

  useEffect(() => {
    /** send it to api */
    if (code) {
      authCtx.saveAccessToken(code, true);
    }
  }, [code]);

  return (
    <>
      <h1>Please wait while we are logging you in!</h1>
    </>
  );
}
